import type { SpreadReadingProfile } from "../types";

export const oneCardReadingProfile: SpreadReadingProfile = {
  spreadId: "spread_one_card",
  sections: [
    {
      id: "mainMeaning",
      title: "Основной смысл",
      source: { type: "keywords" },
    },
    {
      id: "questionContext",
      title: "В контексте вопроса",
      source: { type: "uprightByQuestionContext" },
    },
    {
      id: "readingTips",
      title: "На что обратить внимание",
      source: { type: "readingTips" },
    },
    {
      id: "selfQuestions",
      title: "Вопросы для размышления",
      source: { type: "selfQuestions" },
    },
  ],
};


